<script lang="ts">
  export let ychange: { type: string; user: string } | null;
</script>

{#if ychange}
  {#if ychange.type === "removed"}
    <span class="h-4 w-full bg-red-700/10"></span>
  {/if}
  <span class="ychange-block-hover mb-16 rounded bg-black px-2 font-medium text-white"
    >{ychange?.user || "Team member"}</span
  >
{/if}

<!-- These styles are similar to ones in YChange.ts, but have to differ to accomodate blocks. -->
<style>
  .ychange-block-hover {
    display: none;
  }
  :global(*:hover > .ychange-block-hover) {
    display: inline;
    position: absolute;
    width: max-content;
    top: -30px;
    left: 0;
    font-size: 12px;
    user-select: none;
    word-break: normal;
  }
</style>
